import { useSearchParams } from "@solidjs/router"
import type { JSX } from "solid-js"
import { Match, Switch } from "solid-js"
import { AuthLayout } from "@/components/auth-layout"
import { Box } from "@/designSystem/components/box"
import { Button } from "@/designSystem/components/button"
import { FikaLogo } from "@/designSystem/components/fika-logo"
import { Text } from "@/designSystem/components/text"
import { useI18nContext } from "@/i18n/i18n-solid"
import * as styles from "./unsubscribe.css"

export function Unsubscribe() {
  const { LL } = useI18nContext()
  const [params] = useSearchParams()
  const status = params.status
  const type = params.type
  const reason = params.reason

  return (
    <AuthLayout>
      <Box flexDirection="column" gap="48" alignItems="center">
        <FikaLogo withText />

        <Switch>
          <Match when={status === "success"}>
            <Switch>
              <Match when={type === "writer"}>
                <MessageBox
                  title={LL().unsubscribe.writerSuccess()}
                  description={LL().unsubscribe.writerSuccessDescription()}
                />
              </Match>
              <Match when={type === "marketing"}>
                <MessageBox
                  title={LL().unsubscribe.marketingSuccess()}
                  description={LL().unsubscribe.marketingSuccessDescription()}
                />
              </Match>
              <Match when={type === "weekly_featured"}>
                <MessageBox
                  title={LL().unsubscribe.weeklyFeaturedSuccess()}
                  description={LL().unsubscribe.weeklyFeaturedSuccessDescription()}
                />
              </Match>
            </Switch>
          </Match>

          <Match when={status === "error"}>
            <MessageBox title={LL().unsubscribe.error()}>
              <Switch>
                <Match when={reason === "invalid_token"}>
                  {LL().unsubscribe.invalidToken()}
                </Match>
                <Match when={reason === "missing_token"}>
                  {LL().unsubscribe.missingToken()}
                </Match>
                <Match when={true}>{LL().unsubscribe.genericError()}</Match>
              </Switch>
            </MessageBox>
          </Match>

          <Match when={true}>
            <MessageBox
              title={LL().unsubscribe.invalidRequest()}
              description={LL().unsubscribe.invalidRequestDescription()}
            />
          </Match>
        </Switch>

        <Box flexDirection="column" gap="12" alignItems="center">
          <a href="/auth" class={styles.link}>
            <Button hue="sand" kind="surface" size="m">
              {LL().unsubscribe.signInToManage()}
            </Button>
          </a>
        </Box>
      </Box>
    </AuthLayout>
  )
}

interface MessageBoxProps {
  title: string
  description?: string
  children?: JSX.Element
}

function MessageBox(props: MessageBoxProps) {
  return (
    <Box flexDirection="column" gap="16" alignItems="center">
      <Text fontSize="h2" fontWeight="600" fontFamily="accent" color="sand900">
        {props.title}
      </Text>
      <div class={styles.container}>
        <Text fontSize="m" color="sand700" textAlign="center">
          {props.description ?? props.children}
        </Text>
      </div>
    </Box>
  )
}
